// Sisällön päivityksen tulos ylläpitäjälle. Palvelin (Household.reload_content) palauttaa raportin
// { added, updated, missing: { routes, pois, collections }, unchanged, problems, failed_players };
// tässä se muutetaan lyhyiksi suomenkielisiksi riveiksi.

const KIND_LABEL = { routes: "reittiä", pois: "kohdetta", collections: "kokoelmaa" };
const KIND_ORDER = ["routes", "pois", "collections"];

/** Esim. "28 reittiä, 37 kohdetta, 5 kokoelmaa". */
export function countsText(counts) {
  return KIND_ORDER.filter((k) => counts?.[k] != null).map((k) => `${counts[k]} ${KIND_LABEL[k]}`).join(", ");
}

/** Yksi rivi per ryhmä, jossa on jotain: "Uudet reitit: a, b". */
function group(title, byKind, nouns) {
  return KIND_ORDER.filter((k) => byKind?.[k]?.length).map((k) => `${title} ${nouns[k]}: ${byKind[k].join(", ")}`);
}

/** Raportin rivit { tone: "ok" | "warn", text }. Tyhjä raportti kertoo, ettei mikään muuttunut. */
export function reportLines(report) {
  if (!report) return [];
  const lines = [
    ...group("Uudet", report.added, { routes: "reitit", pois: "kohteet", collections: "kokoelmat" }),
    ...group("Päivitetyt", report.updated, { routes: "reitit", pois: "kohteet", collections: "kokoelmat" }),
    ...group("Puuttuvat", report.missing, { routes: "reitit", pois: "kohteet", collections: "kokoelmat" }).map(
      (t) => `${t} (säilyvät pelissä, suoritukset eivät katoa)`,
    ),
  ].map((text) => ({ tone: text.startsWith("Puuttuvat") ? "warn" : "ok", text }));
  if (!lines.length) lines.push({ tone: "ok", text: "Ei muutoksia: sisältö oli jo ajan tasalla." });
  if (report.rebuilt) lines.push({ tone: "ok", text: "Uudet kohteet tarkistettiin vanhoista retkistä." });
  for (const p of report.problems ?? []) lines.push({ tone: "warn", text: `Ohitettu: ${p}` });
  if (report.failed_players?.length) lines.push({ tone: "warn", text: `Päivitys epäonnistui pelaajille: ${report.failed_players.join(", ")}` });
  return lines;
}

/** Onko jotain, mikä vaatii ylläpitäjän huomion (virhe pakettitiedostossa tai epäonnistunut päivitys)? */
export function needsAttention(statusOrReport) {
  return Boolean(statusOrReport?.problems?.length || statusOrReport?.failed_players?.length);
}
